// import React, { useEffect, useRef, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const CollectionModelPopup = ({CollectionVisitDataFunc}) => {
//   const initialTableData = [
//     {
//       module: "Projects",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Tasks",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Chat",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Estimates",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Invoices",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Timing Sheets",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//   ];

//   //   let yourDate = new Date()
//   // // yourDate.toISOString().split('T')[0]

//   // const today=(yourDate.toISOString().split('T')[0])

//   const [tableData, setTableData] = useState(initialTableData)

//   // const [userId,setUserId] = useState('')

//   // useEffect(() => {
//   //  const id= JSON.parse(sessionStorage.getItem('user'))
//   // setUserId(id)
//   // }, [])

//   const fileInputRef = useRef(null);

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [radioValue, setRadioValue] = useState(false);

//   const [isCollected, setIsCollected] = useState(false)
//   const [isNotCollected, setIsNotCollected] = useState(false)
//   const [isPartialCollected, setIsPartialCollected] = useState(false)

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({
//     BranchId: Number,
//     Name: "",
//     Mobile: "",
//     ReferenceNumber: "",
//     IsEMICollected: 0,
//     Selfie: null,
//     ExpectedDate: "",
//     Latitude: "",
//     Longitude: "",
//   });

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     setLocalFormData({ ...LocalFormData, Selfie: file });
//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, ExpectedDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const HandleSubmit = async () => {

//     const formatDateToUTC = (dateString) => {
//       const date = new Date(dateString);
//       const year = date.getUTCFullYear();
//       const month = String(date.getUTCMonth() + 1).padStart(2, '0');
//       const day = String(date.getUTCDate()).padStart(2, '0');
//       const hours = String(date.getUTCHours()).padStart(2, '0');
//       const minutes = String(date.getUTCMinutes()).padStart(2, '0');
//       const seconds = String(date.getUTCSeconds()).padStart(2, '0');
//       const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
//       return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
//     };

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     }

//     console.log(isCollected, isNotCollected, isPartialCollected)

//     setLocalFormData(prev => ({
//       ...prev,
//       IsEMICollected: isCollected,
//     }))

//     let collectedStatus = 0;
//     if (isCollected) {
//       collectedStatus = 1;
//     } else if (isPartialCollected) {
//       collectedStatus = 2;
//     } else if (isNotCollected) {
//       collectedStatus = 3;
//     }

//     const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     formData.append("ReferenceNumber", LocalFormData.ReferenceNumber);
//     formData.append("IsEMICollected", collectedStatus);
//     formData.append("Selfie", LocalFormData.Selfie);
//     // formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);

//     if (isNotCollected || isPartialCollected) {
//       formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     }

//     // console.log(formData)

//     try {
//       const response = await axios.post(`${Api_Url}api/v1/EMICollection`, formData, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//           "Content-Type": "multipart/form-data",
//         }
//       })
//       console.log(response)
//       CollectionVisitDataFunc()
//       resetForm()
//       SuccessToast("Collectionm Data Submitted Successfully")
//     } catch (error) {
//       return error.message;
//     }
//   }

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//       Name: "",
//       Mobile: "",
//       ReferenceNumber: "",
//       IsEMICollected: 0,
//       Selfie: null,
//       ExpectedDate: "",
//     });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   const [allbranch, setAllBranch] = useState('')

//   const AllBranchName = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data)
//     } catch (error) {
//       console.log("object", error)
//     }
//   }
//   console.log(allbranch)

//   useEffect(() => {
//     AllBranchName()
//   }, [])

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });
//     }}

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Collection Visit</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length > 0 && allbranch.map((res) => (
//                           <option value={res.id}>{res.name}</option>
//                         ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control"
//                         type="text" value={LocalFormData.Name}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={handleMobileChange} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
//                     <input
//                       className="form-control"
//                       type="file"
//                       accept="image/*"
//                       ref={fileInputRef}
//                       // value={LocalFormData.Selfie}
//                       onChange={handleFileChange}
//                     />
//                   </div>

//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       EMI Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         // value="collected"
//                         checked={isCollected}
//                         onChange={(e) => { setIsCollected(e.target.checked); setIsNotCollected(false); setIsPartialCollected(false); }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault2"
//                         id="flexRadioDefault2"
//                         // value="partial collected"
//                         checked={isPartialCollected}
//                         onChange={(e) => { setIsPartialCollected(e.target.checked); setIsCollected(false) }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         Partial Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault2"
//                         id="flexRadioDefault3"
//                         // value="not collected"
//                         checked={isNotCollected}
//                         onChange={(e) => { setIsNotCollected(e.target.checked); setIsCollected(false) }}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault3">
//                         Not Collected
//                       </label>
//                     </div>
//                   </div>

//                   {/* isEmiCollected = isCollected == true && ... */}

//                   {
//                     isCollected === true && isNotCollected === false && isPartialCollected === false ? (
//                       <div className="col-md-6">
//                         <div className="input-block mb-3">
//                           <label className="col-form-label">
//                             ReferenceNumber <span className="text-danger">*</span>
//                           </label>
//                           <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                         </div>
//                       </div>
//                     )
//                       // : isNotCollected === true || isPartialCollected === true && isCollected === false ?
//                       //   (<div div className="col-md-6">
//                       //     <div className="input-block mb-3">
//                       //       <label className="col-form-label">
//                       //         Visit Date <span className="text-danger">*</span>
//                       //       </label>
//                       //       <DatePicker
//                       //         selected={LocalFormData.ExpectedDate}
//                       //         onChange={handleDateChange}
//                       //         className="form-control"
//                       //       />
//                       //     </div>
//                       //   </div>
//                       //   ) : (isNotCollected === false || isPartialCollected === true && isPartialCollected === false || isNotCollected === true) ?
//                       //     (<div div className="col-md-6">
//                       //       <div className="input-block mb-3">
//                       //         <label className="col-form-label">
//                       //           Visit Date <span className="text-danger">*</span>
//                       //         </label>
//                       //         <DatePicker
//                       //           selected={LocalFormData.ExpectedDate}
//                       //           onChange={handleDateChange}
//                       //           className="form-control"
//                       //         />
//                       //       </div>
//                       //     </div>) :
//                       //     (
//                       //       <div className="col-md-6">
//                       //         <div className="input-block mb-3">
//                       //           <label className="col-form-label">
//                       //             ReferenceNumber <span className="text-danger">*</span>
//                       //           </label>
//                       //           <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                       //         </div>
//                       //       </div>)
//                       :
//                       isCollected === false && isPartialCollected === false && isNotCollected === false ? null : (<div div className="col-md-6">
//                         <div className="input-block mb-3">
//                           <label className="col-form-label">
//                             Visit Date <span className="text-danger">*</span>
//                           </label>
//                           <DatePicker
//                             selected={LocalFormData.ExpectedDate}
//                             onChange={handleDateChange}
//                             className="form-control"
//                           />
//                         </div>
//                       </div>)
//                   }

//                   {/* if (isCollected === true ) {
//                     <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                       ReferenceNumber <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                     </div>
//                   </div>
//                   }else if (isNotCollected === true || isPartialCollected === true){
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   }else if(isCollected === false || isNotCollected === true || isPartialCollected === false){
//                     <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Visit Date <span className="text-danger">*</span>
//                       </label>
//                       <DatePicker
//                         selected={LocalFormData.ExpectedDate}
//                         onChange={handleDateChange}
//                         className="form-control"
//                       />
//                     </div>
//                   </div>
//                   }else{
//                     ""
//                   }
//                   } */}

//                   {/* Conditional rendering based on radio selection */}
//                   {/* {(LocalFormData.IsEMICollected === "partial collected" || LocalFormData.IsEMICollected === "not collected") ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   ):  <div className="col-md-6">
//                   <div className="input-block mb-3">
//                     <label className="col-form-label">
//                     ReferenceNumber <span className="text-danger">*</span>
//                     </label>
//                     <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
//                   </div>
//                 </div>} */}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div >
//       </div >

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         First Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="Barry"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Last Name</label>
//                       <input
//                         className="form-control"
//                         defaultValue="Cuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Username <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="barrycuda@example.com"
//                         type="email"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Confirm Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Client ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="CLT-0001"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Phone </label>
//                       <input
//                         className="form-control"
//                         defaultValue={9876543210}
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Company Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Global Technologies"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="table-responsive m-t-15">
//                   <table className="table table-striped custom-table">
//                     <thead>
//                       <tr>
//                         <th>Module Permission</th>
//                         <th className="text-center">Read</th>
//                         <th className="text-center">Write</th>
//                         <th className="text-center">Create</th>
//                         <th className="text-center">Delete</th>
//                         <th className="text-center">Import</th>
//                         <th className="text-center">Export</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData.map((row, index) => (
//                         <tr key={index}>
//                           <td>{row.module}</td>
//                           {[
//                             "read",
//                             "write",
//                             "create",
//                             "delete",
//                             "import",
//                             "export",
//                           ].map((column) => (
//                             <td key={column} className="text-center">
//                               <label className="custom_check">
//                                 <input
//                                   type="checkbox"
//                                   checked={row[column]}
//                                   onChange={() =>
//                                     handleCheckboxChange(row.module, column)
//                                   }
//                                 />
//                                 <span className="checkmark"></span>
//                               </label>
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// modal

import React, { useEffect, useRef, useState } from "react";
import { AllFormsUpperphoto, Applogo, profileLogo } from "../../../Routes/ImagePath";
import { DatePicker, Modal } from "antd";
import { Radio } from "react-feather";
import { useNavigate } from "react-router-dom";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

export const CollectionModelPopup = ({ CollectionVisitDataFunc, onClose }) => {

  const fileInputRef = useRef(null);

  const AllFileLoginData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      console.log("id", id);
      const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
        },
      });
      console.log("response", response);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    AllFileLoginData();
  }, []);


  const [isCollected, setIsCollected] = useState(false);
  const [isNotCollected, setIsNotCollected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPartialCollected, setIsPartialCollected] = useState(false);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    ReferenceNumber: "",
    IsEMICollected: 0,
    Selfie: null,
    ExpectedDate: null,
    Latitude: "",
    Longitude: "",
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setLocalFormData({ ...LocalFormData, Selfie: file });
  };

  const handleDateChange = (date) => {
    setLocalFormData({ ...LocalFormData, ExpectedDate: date });
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData({
          ...LocalFormData,
          Latitude: latitude,
          Longitude: longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const validateForm = () => {
    if (!LocalFormData.BranchId) {
      ErrorToast("Please select a branch.");
      return false;
    }
    if (!LocalFormData.Name) {
      ErrorToast("Please enter the customer's name.");
      return false;
    }
    if (!LocalFormData.Mobile || LocalFormData.Mobile.length !== 10) {
      ErrorToast("Please enter a valid 10-digit mobile number.");
      return false;
    }
    if (!LocalFormData.Selfie) {
      ErrorToast("Please upload a document.");
      return false;
    }
    if (!isCollected && !isPartialCollected && !isNotCollected) {
      ErrorToast("Please select EMI collection status.");
      setLoading(false);
      return false;
    }
    if (isCollected && !LocalFormData.ReferenceNumber) {
      ErrorToast("Please enter the reference number for full collection.");
      return false;
    }
    if ((isPartialCollected || isNotCollected) && !LocalFormData.ExpectedDate) {
      ErrorToast("Please select an expected visit date for partial or no collection.");
      return false;
    }
    return true;
  };

  const HandleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);
    const formatDateToUTC = (dateString) => {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      const hours = String(date.getUTCHours()).padStart(2, "0");
      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
      const seconds = String(date.getUTCSeconds()).padStart(2, "0");
      const milliseconds = String(date.getUTCMilliseconds()).padStart(3, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    };

    let collectedStatus = 0;
    if (isCollected) {
      collectedStatus = 1;
    } else if (isPartialCollected) {
      collectedStatus = 2;
    } else if (isNotCollected) {
      collectedStatus = 3;
    }

    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("ReferenceNumber", LocalFormData.ReferenceNumber);
    formData.append("IsEMICollected", collectedStatus);
    formData.append("Selfie", LocalFormData.Selfie);
    if (isNotCollected || isPartialCollected) {
      formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
    }
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/EMICollection`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(response);
      CollectionVisitDataFunc();
      resetForm();
      SuccessToast("Collection Data Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An Error Occurred while Submitting.");
      return error.message;
    }
    setLoading(false);
  };

  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      ReferenceNumber: "",
      IsEMICollected: 0,
      Selfie: null,
      ExpectedDate: null,
      Latitude: "",
      Longitude: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setIsCollected(false);
    setIsNotCollected(false);
    setIsPartialCollected(false);
  };

  const [allbranch, setAllBranch] = useState([]);

  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
          },
        }
      );
      setAllBranch(response.data.data);
    } catch (error) {
      console.log("Error fetching branches", error);
    }
  };

  useEffect(() => {
    AllBranchName();
  }, []);

  const validateMobileNumber = (number) => {
    const regex = /^[0-9]{0,10}$/;
    return regex.test(number);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (validateMobileNumber(value)) {
      setLocalFormData({
        ...LocalFormData,
        Mobile: value,
      });
    }
  };

  return (
    <Modal
    title={<h4>Add Collection Visit</h4>}
    open={true}
    onOk={onClose}
    onCancel={onClose}
    footer={[
      <div
        className="d-flex justify-content-between align-items-center"
        key="footer"
      >
        <button className="btn btn-danger submit-btn" onClick={onClose}>
          Cancel
        </button>
        <button
          className="btn btn-primary submit-btn"
          onClick={HandleSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>
      </div>,
    ]}
    width={600}
    maskClosable={false}
    closeIcon={<span style={{ color: "red" }}>X</span>}
  >
    <div className="modal-body mt-5">
      <div className="profile-image text-center mt-4 mb-4">
        <img
          src={AllFormsUpperphoto}
          alt="Profile"
          className="img-fluid rounded-circle"
          style={{ width: "100px", height: "100px" }}
        />
      </div>
      <form>
            <div className="row">
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Branch <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={LocalFormData.BranchId}
                    onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
                  >
                    <option value="">Select Branch</option>
                    {allbranch && allbranch.length > 0 && allbranch.map((res) => (
                      <option value={res.id}>{res.name}</option>
                    ))}
                    {/* Add more branches as needed */}
                  </select>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
                  <input className="form-control"
                    type="text" value={LocalFormData.Name}
                    onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Mobile <span className="text-danger">*</span>
                  </label>
                  <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={handleMobileChange} />
                </div>
              </div>
              <div className="col-md-6">
                <label className="col-form-label">Upload Document <span className="text-danger">*</span></label>
                <input
                  className="form-control"
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  // value={LocalFormData.Selfie}
                  onChange={handleFileChange}
                />
              </div>

              <div className="col-md-12">
                <label className="col-form-label">
                  EMI Collected <span className="text-danger">*</span>
                </label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                    // value="collected"
                    checked={isCollected}
                    onChange={(e) => { setIsCollected(e.target.checked); setIsNotCollected(false); setIsPartialCollected(false); }}
                  />
                  <label className="form-check-label" htmlFor="flexRadioDefault1">
                    Collected
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault2"
                    id="flexRadioDefault2"
                    // value="partial collected"
                    checked={isPartialCollected}
                    onChange={(e) => { setIsPartialCollected(e.target.checked); setIsCollected(false) }}
                  />
                  <label className="form-check-label" htmlFor="flexRadioDefault2">
                    Partial Collected
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault2"
                    id="flexRadioDefault3"
                    // value="not collected"
                    checked={isNotCollected}
                    onChange={(e) => { setIsNotCollected(e.target.checked); setIsCollected(false) }}
                  />
                  <label className="form-check-label" htmlFor="flexRadioDefault3">
                    Not Collected
                  </label>
                </div>
              </div>

              
              {
                isCollected === true && isNotCollected === false && isPartialCollected === false ? (
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        ReferenceNumber <span className="text-danger">*</span>
                      </label>
                      <input className="form-control" type="number" value={LocalFormData.ReferenceNumber} onChange={(e) => setLocalFormData({ ...LocalFormData, ReferenceNumber: e.target.value })} />
                    </div>
                  </div>
                )
                 
                  :
                  isCollected === false && isPartialCollected === false && isNotCollected === false ? null : (<div div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Visit Date <span className="text-danger">*</span>
                      </label>
                      <DatePicker
                        selected={LocalFormData.ExpectedDate}
                        onChange={handleDateChange}
                        className="form-control"
                      />
                    </div>
                  </div>)
              }
            </div>
          </form>
    </div>
  </Modal>
  );
};

